'use strict';

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../../styles/theme.scss');

require('../../styles/bundles/index.scss');

var _langSwitcher = require('../globals/lang-switcher');

var _langSwitcher2 = _interopRequireDefault(_langSwitcher);

require('../globals/cookie-support');

var _themeA11y = require('@shopify/theme-a11y');

var _themeSections = require('@shopify/theme-sections');

var _headerHeightScroll = require('../globals/header-height-scroll');

var _headerHeightScroll2 = _interopRequireDefault(_headerHeightScroll);

var _resize = require('../globals/resize');

var _resize2 = _interopRequireDefault(_resize);

var _scroll = require('../globals/scroll');

var _scroll2 = _interopRequireDefault(_scroll);

var _googleAnalytics = require('../components/google-analytics-4');

var _googleAnalytics2 = _interopRequireDefault(_googleAnalytics);

require('../sections/newsletter');

require('../sections/article-header');

require('../sections/article-related-post');

require('../vue/vue-theme');

require('../globals/menu-drawer');

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Add imports which depend on Vuex
// TODO - convert these to vue components

// import '../../styles/theme.scss.liquid';
new _googleAnalytics2.default();
// TODO -comprobar que esto se puede eliminar


// Vue Components

// Intersection observer polyfill for IE11. Do we really need this?
// require('intersection-observer');

// lazysizes - Adds 24kb tovendors@layout.theme


(0, _themeSections.load)('*');

new _headerHeightScroll2.default().initEvents();

(0, _resize2.default)();
(0, _scroll2.default)();
(0, _langSwitcher2.default)();

// Accesibility fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

// Anchor smooth animation
document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
  anchor.addEventListener('click', function (event) {
    event.preventDefault();
    var yOffset = -88;
    var id = this.getAttribute('href');
    var element = document.querySelector(id);
    var y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });
});

// Set global CSS variable for viewport units on mobile
var vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', vh + 'px');

window.addEventListener('resize', function () {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh + 'px');
});